import PageMeta from '@/components/base/PageMeta';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '天天影院',
    url: 'https://tiantiancinema.com',
    description: '天天影视为您整理最新电视剧全集、国产剧全集在线、韩剧全集免费、美剧全集播放与日剧全集资源，追剧无需等待，全部剧集一网打尽。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://tiantiancinema.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '天天影院',
    url: 'https://tiantiancinema.com',
    description: '天天影视为您整理最新电视剧全集、国产剧全集在线、韩剧全集免费、美剧全集播放与日剧全集资源。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-8888',
      contactType: 'customer service',
      email: 'contact@tiantiancinema.com',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      { '@type': 'Question', name: '天天影院需要注册会员才能观看吗？', acceptedAnswer: { '@type': 'Answer', text: '不需要。天天影院目前所有内容均免费提供，您无需注册即可浏览和观看所有剧集信息。' } },
      { '@type': 'Question', name: '剧集更新的频率是怎样的？', acceptedAnswer: { '@type': 'Answer', text: '我们会在各大平台更新后第一时间同步最新剧集信息。热门剧集通常在播出后24小时内完成更新。' } },
      { '@type': 'Question', name: '支持哪些设备观看？', acceptedAnswer: { '@type': 'Answer', text: '天天影院采用响应式设计，完美支持电脑、平板和手机等多种设备。' } },
      { '@type': 'Question', name: '如何快速找到我想看的剧集？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过首页顶部的分类导航快速筛选您感兴趣的类型，也可以使用搜索功能直接查找。' } },
      { '@type': 'Question', name: '剧集画质如何？有高清版本吗？', acceptedAnswer: { '@type': 'Answer', text: '天天影院提供的剧集资源均支持高清画质，多部热门剧集还支持超高清版本。' } },
    ],
  };

  return (
    <>
      <PageMeta
        title="天天影院 | 最新电视剧全集在线观看，国产剧韩剧全集免费美剧日剧播放不缓冲"
        description="天天影视为您整理最新电视剧全集、国产剧全集在线、韩剧全集免费、美剧全集播放与日剧全集资源，追剧无需等待，全部剧集一网打尽。"
        keywords="天天影院,最新电视剧全集,国产剧全集在线,韩剧全集免费,美剧全集播放,日剧全集资源,全集追剧,完整剧集,免费在线观看"
        canonicalUrl="https://tiantiancinema.com/"
        ogTitle="天天影院 | 最新电视剧全集在线观看"
        ogDescription="天天影视为您整理最新电视剧全集、国产剧全集在线、韩剧全集免费、美剧全集播放与日剧全集资源，追剧无需等待，全部剧集一网打尽。"
        ogUrl="https://tiantiancinema.com/"
        schemaObjects={[websiteSchema, orgSchema, faqSchema]}
      />

      <article>
        <HeroSection />
        <CategoryNav />
        <FeaturedSection />
        <LatestSection />
        <FAQSection />
      </article>
    </>
  );
}